import { render, staticRenderFns } from "./treaty.vue?vue&type=template&id=0b1be5fb&scoped=true"
import script from "./treaty.vue?vue&type=script&lang=js"
export * from "./treaty.vue?vue&type=script&lang=js"
import style0 from "./treaty.vue?vue&type=style&index=0&id=0b1be5fb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1be5fb",
  null
  
)

export default component.exports